module.exports = __webpack_public_path__ + "static/media/img1.c9281c00.jpg";